// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"gg","itemsContainer":"hg"};